import { Layout, Space, Tag, theme } from 'antd';
import React, { ReactNode } from 'react';
import { BrowserTabsProvider } from '../components/BrowserTabs';
import Logo from '../components/Logo';
import UserMenu from '../components/UserMenu';
import WSWebSocketStatus from '../components/WebSocketStatus';
import { useAuth } from '../contexts/AuthContext';

const { Header, Content } = Layout;
const { useToken } = theme;

interface AppLayoutProps {
  children: ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { token } = useToken();
  const { userRole } = useAuth();
  const isAdmin = userRole === 'admin';

  return (
    <BrowserTabsProvider>
      <Layout style={{ minHeight: '100vh', height: '100vh', overflow: 'hidden' }}>
        <Header style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: token.colorBgContainer,
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
          padding: '0 24px',
          overflow: 'hidden',
          minWidth: 0,
          flexShrink: 0
        }}>
          <Logo style={{ flex: '1', minWidth: 0 }} />
          <Space size="large" align="center">
            {isAdmin && (
              <Tag color="gold" style={{ margin: 0 }}>
                Admin
              </Tag>
            )}
            <WSWebSocketStatus />
            <UserMenu />
          </Space>
        </Header>
        <Content style={{ padding: '24px', overflow: 'auto', flex: 1 }}>
          {children}
        </Content>
      </Layout>
    </BrowserTabsProvider>
  );
};

export default AppLayout;
